
export default {
  name: "InquiryForm",
  data() {
    return {
      status: 1,
      form: {
        name: {
          label: "name",
          value: "",
          showMessage: false,
        },
        email: {
          label: "email",
          value: "",
          showMessage: false,
        },
        phoneNumber: {
          label: "phoneNumber",
          value: "",
          showMessage: false,
        },
        company: {
          label: "company",
          value: "",
          showMessage: false,
        },
        title: {
          label: "title",
          value: "",
          showMessage: false,
        },
        content: {
          label: "content",
          value: "",
          showMessage: false,
        },
      },
      formRules: {
        name: [
          {
            require: false,
            message: "Please enter your name",
          },
        ],
        email: [
          {
            require: false,
            message: "Please enter your email",
          },
          {
            type: "email",
            message: "Please enter the correct email address",
          },
        ],
        phoneNumber: [
          {
            require: false,
            message: "Please enter your phoneNumber",
          },
        ],
        company: [
          {
            require: false,
            message: "Please enter your company",
          },
        ],
        title: [
          {
            require: false,
            message: "Please enter your title",
          },
        ],
        content: [
          {
            require: true,
            message: "Please enter your content",
          },
        ],
      },
    };
  },
  created() {
    if (!this.$store.state.askData) return;
    for (let i in this.formRules) {
      if (
        this.$store.state.askData[i] &&
        this.$store.state.askData[i].required
      ) {
        this.formRules[i][0].require = true;
      }
    }
  },
  methods: {
    async submitForm() {
      this.status = 1;
      for (let i in this.form) {
        if (this.getRequire(i) && !this.form[i].value) {
          this.form[i].showMessage = true;
        }
      }

      let bool = Object.entries(this.form)
        .map(function ([key, value]) {
          return value;
        })
        .every(v => !v.showMessage);
      const url = new URL("https://ipadmin.aixdb.cn/ipadmin/api/ask/add");

      if (bool) {
        let params = {};
        Object.entries(this.form).forEach(([label, val]) => {
          params[label] = val.value;
        });
        params = {
          ...params,
          DynamicDbConnectName: this.$store.state.footerData.inquiry,
          domain: window.location.host,
          path: window.location.href,
          tel: params.phoneNumber,
        };
        for (let i in params) {
          url.searchParams.append(i, params[i]);
        }
        const res = await fetch(url);
        if (res.ok) {
          const result = await res.json();
          if (result.status == 0) {
            this.$message.success(
              "We have received your message and will be in touch with you shortly.",
            );
          } else {
            this.$message.error("Server Internal Error");
            return;
          }
        } else {
          this.$message.error("Server Internal Error");
          return;
        }
        this.clearForm();
        window.location.href = "/thanks";
      }
    },
    changeVal() {
      const re = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);

      if (!re.test(this.form.email.value)) {
        this.form.email.showMessage = true;
      } else {
        this.form.email.showMessage = false;
      }
    },
    getRequire(name) {
      if (this.formRules[name]) {
        return this.formRules[name].some(v => v.require);
      }
    },
    clearForm() {
      this.status = 2;
      for (let i in this.form) {
        this.form[i].value = "";
        this.form[i].showMessage = false;
      }
      setTimeout(() => {
        this.status = 1;
      }, 500);
    },
    handleShowMessage(val) {
      this.form[val.label].showMessage = val.showMessage;
    },
  },
};
